<template>
  <div>
    <!-- <h5 class="mb-4">{{ $t('coupin setting') }}</h5> -->
    <Typography h2 bold label="การตั้งค่าระบบ TechHunt" />

    <div class="ml-5">
      <Typography h4 bold label="การตั้งค่าคูปอง" class="mt-4" />
      <v-card
        class="mt-2"
        style="border-radius: 10px; padding: 18px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
      >
        <Typography h4 bold label="ตั้งค่าวันหมดอายุ" />
        <Typography
          h4
          color="color-error"
          medium
          label="*จำนวนวันที่คูปองจะหมดอายุ นับตั้งแต่วันที่ขอ"
        />
        <v-layout class="mt-4">
          <Typography v-if="!editExp" h4 medium :label="showData.exp" />
          <input
            v-else-if="editExp"
            type="number"
            style="width: 50px; margin: 0px"
            class="form-control"
            name="ชื่อสมาชิก"
            v-model="exp"
          />
          <Typography
            h4
            medium
            label="วัน"
            class="ml-2"
            style="display: flex; align-items: center"
          />
          <img
            v-if="!editExp"
            @click="editExp = true"
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer ml-3"
            style="height: 22px"
          />
        </v-layout>
        <v-layout v-if="editExp" justify-center>
          <v-btn color="primary" @click="saveExp">ตกลง</v-btn>
          <v-btn
            @click="
              exp = showData.exp
              editExp = false
            "
            >ยกเลิก</v-btn
          >
        </v-layout>
      </v-card>

      <!-- <v-card
        class="mt-3"
        style="border-radius: 10px; padding: 18px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
      >
        <Typography h4 bold label="จำนวนสิทธิ์ที่สามารถขอได้" />
        <Typography
          h4
          color="color-error"
          medium
          label="*เปอร์เซนต์ของจำนวนสิทธิ์ที่สามารถขอได้ในแต่ละโครงการ"
        />
        <v-layout class="mt-4">
          <Typography v-if="!editRequest" h4 medium :label="showData.request" />
          <input
            v-else-if="editRequest"
            type="number"
            style="width: 50px; margin: 0px"
            class="form-control"
            name="ชื่อสมาชิก"
            v-model="request"
          />
          <Typography h4 medium label="%" class="ml-2" style="display: flex; align-items: center" />
          <img
            v-if="!editRequest"
            @click="editRequest = true"
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer ml-3"
            style="height: 22px"
          />
        </v-layout>
        <v-layout v-if="editRequest" justify-center>
          <v-btn color="primary" @click="saveRequest">ตกลง</v-btn>
          <v-btn
            @click="
              request = showData.request
              editRequest = false
            "
            >ยกเลิก</v-btn
          >
        </v-layout>
      </v-card> -->

      <Typography h4 bold :label="$t('product setting')" class="mt-5" />
      <v-card
        class="mt-2"
        style="border-radius: 10px; padding: 18px; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15)"
      >
        <Typography h4 bold label="จำนวนการแก้ไขสินค้าได้หากมีการเข้าร่วมแคมเปญแล้ว" />
        <v-layout class="mt-4">
          <Typography v-if="!editproduct" h4 medium :label="showDataProduct" />
          <input
            v-else-if="editproduct"
            type="number"
            style="width: 50px; margin: 0px"
            class="form-control"
            name="ชื่อสมาชิก"
            v-model="product"
          />
          <Typography h4 medium label="ครั้ง" class="ml-2" style="display: flex; align-items: center" />
          <img
            v-if="!editproduct"
            @click="editproduct = true"
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img pointer ml-3"
            style="height: 22px"
          />
        </v-layout>
        <v-layout v-if="editproduct" justify-center>
          <v-btn color="primary" @click="saveProduct">ตกลง</v-btn>
          <v-btn
            @click="
              product = showDataProduct
              editproduct = false
            "
            >ยกเลิก</v-btn
          >
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Typography from '@/components/elements/Typography.vue'

export default {
  components: { Typography },
  data() {
    return {
      loading: false,
      editExp: false,
      editRequest: false,
      editproduct: false,
      exp: null,
      product: null,
      request: null,
      showDataProduct: '',
      showData: {
        exp: '',
        request: '',
      },
    }
  },
  computed: {},
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.getCouponConfig()
      this.getProductConfig()
    },
    async getCouponConfig() {
      let res = await api.getCouponConfig()
      if (res) {
        this.showData = res
        this.exp = res.exp
        this.request = res.request
      }
      // console.log(res);
    },
    async getProductConfig() {
      let res = await api.getProductConfig()
      if (res) {
        this.showDataProduct = res
        this.product = res
      }
      // console.log(res);
    },
    async saveProduct() {
      let code = await api.updateProductConfig({ product: this.product })
      console.log(code)
      if (code == 204) {
        await this.getProductConfig()
        this.editproduct = false
      } else if (code == 300) {
        this.$swal.fire({
          title: 'Input negative numbers',
          type: 'error',
        })
      }
    },
    async saveExp() {
      let code = await api.updateCouponConfig({ exp: this.exp })
      console.log(code)
      if (code == 204) {
        await this.getCouponConfig()
        this.editExp = false
      } else if (code == 300) {
        this.$swal.fire({
          title: 'Input negative numbers',
          type: 'error',
        })
      }
    },
    async saveRequest() {
      let code = await api.updateCouponConfig({ request: this.request })
      console.log(code)
      if (code == 204) {
        await this.getCouponConfig()
        this.editRequest = false
      } else if (code == 300) {
        this.$swal.fire({
          title: 'Input negative numbers',
          type: 'error',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/techhuntTechhuntsetting/main.vue